import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { EventService } from '../service/event.service';
import { SessionExpireProgressBarEvent, SessionExpireEvent, ShowLoaderEvent } from "../service/events";

@Component({
  selector: 'app-session-expire',
  templateUrl: './session-expire.component.html',
  styleUrls: ['./session-expire.component.scss']
})
export class SessionExpireComponent implements OnInit {

  sessionExpireProgress: number = 0;
  minutesLeft: number = 0;

  constructor(public dialogSessionExpireRef: MatDialogRef<SessionExpireComponent>, private router: Router, private eventBus: EventService) {
    dialogSessionExpireRef.disableClose = true;
  }

  ngOnInit() {
    this.eventBus.on(
      SessionExpireProgressBarEvent,
      (event): void => {
        this.sessionExpireProgress = event.payload.progress;
        this.minutesLeft = event.payload.minutesLeft;
      }
    );

    this.eventBus.on(
      SessionExpireEvent,
      (event): void => {
        setTimeout(() => {
          if ("End Session" == event.payload.text) {
            this.onNoClick();
            this.eventBus.emit(new ShowLoaderEvent({ show: false }));
            this.router.navigate(['sessionTimedOut']);
          } else if ("Extend Session" == event.payload.text) {
            this.onNoClick();
          }
        });
      }
    );
  }

  onNoClick(): void {
    this.eventBus.emit(new SessionExpireEvent({ text: "Cancel Session" }));
    this.dialogSessionExpireRef.close();
  }

  extendSession(): void {
    this.eventBus.emit(new SessionExpireEvent({ text: "Extend Session" }));
  }
}
